





























































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import FscSimpleCard from "@/components/Card/FscSimpleCard.vue";
import SaveButton from "@/components/Button/SaveButton.vue";
import AbortButton from "@/components/Button/AbortButton.vue";
import Validation from "@/components/Validation.vue";
import { Validations } from "vuelidate-property-decorators";
import { email, required } from "vuelidate/lib/validators";
import FscMultiselect from "@/components/FscMultiselect.vue";
import { mixins } from "vue-class-component";
import CompanyMixin from "@/mixins/CompanyMixin";
import { namespace } from "vuex-class";

const TestingOrganizationsModule = namespace("testing-organizations");
@Component({
  components: {
    FscSimpleCard,
    SaveButton,
    AbortButton,
    Validation,
    FscMultiselect,
  },
})
export default class TestingOrganizationForm extends mixins(CompanyMixin) {
  public name = "TestingOrganizationForm";

  @Prop()
  testingOrganization!: any;

  @Prop({ type: Boolean, required: false, default: () => false })
  public putLoading!: boolean;

  @TestingOrganizationsModule.Action("findAllTuevSystems")
  public findAllTuevSystems: any;

  @TestingOrganizationsModule.Getter("getTuevSystems")
  public tuevSystems: any;

  public isTuevSUD = false;

  public organization = {
    name: "",
    contactPerson: "",
    email: "",
    postalCode: "",
    location: "",
    address: "",
    phone: "",
    info: "",

    tuevSystem: "",
    tuevSystemUsername: "",
    tuevSystemPassword: "",
    tuevSystemSecret: "",
  };

  public async mounted(): Promise<void> {
    this.organization = this.testingOrganization;
    await this.findAllTuevSystems();
  }

  public onAbort(): void {
    this.$emit("on-abort");
  }

  public onSubmit(): void {
    if (this.hasNotPermissionWrite) return;
    this.$v.$touch();
    if (this.$v.$invalid) return;

    const testOrg = {
      name: this.organization.name,
      contactPerson: this.organization.contactPerson,
      email: this.organization.email,
      postalCode: this.organization.postalCode,
      location: this.organization.location,
      address: this.organization.address,
      phone: this.organization.phone,
      info: this.organization.info,

      tuevSystem: this.organization.tuevSystem,
      tuevSystemUsername: this.organization.tuevSystemUsername,
      tuevSystemPassword: this.organization.tuevSystemPassword,
      tuevSystemSecret: this.organization.tuevSystemSecret,
    };
    this.$emit("on-submit", testOrg);
  }

  @Validations()
  public validations(): Record<string, any> {
    return {
      organization: {
        name: { required },
        email: { required, email },
        postalCode: { required },
        location: { required },
        address: { required },
      },
    };
  }

  @Watch("testingOrganization", { immediate: true, deep: true })
  public onTestingOrganizationChange(testOrg: any): void {
    if (testOrg) {
      this.organization = testOrg;
    }
    if (testOrg.tuevSystem == "SUD") {
      this.isTuevSUD = true;
    } else {
      this.isTuevSUD = false;
    }
  }
}
